import { motion } from "framer-motion";

export default function Navbar() {
  return (
    <motion.nav
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="fixed top-4 w-full flex justify-center z-30 px-2"
    >
      <div className="bg-white/10 backdrop-blur-md px-2 sm:px-4 py-1 sm:py-2 rounded-full flex items-center overflow-x-auto whitespace-nowrap text-white shadow-lg text-[11px] sm:text-sm md:text-base">
        <a href="#home" className="px-2 sm:px-3 py-1 hover:underline">
          Home
        </a>
        <a href="#services" className="px-2 sm:px-3 py-1 hover:underline">
          Services
        </a>
        <a href="#about" className="px-2 sm:px-3 py-1 hover:underline">
          About
        </a>
        <a href="#reviews" className="px-2 sm:px-3 py-1 hover:underline">
          Reviews
        </a>
        <a
          href="#contact"
          className="px-2 sm:px-3 py-1 hover:underline rounded-full border  hover:bg-yellow-400 hover:text-black border-yellow-400 bg-white/20"
        >
          Contact
        </a>
      </div>
    </motion.nav>
  );
}
